import { transformLinkToGraphQL } from './transform-link-to-graphql';

/**
 * Transform a Contentful SDK fact item to GraphQL Fact format
 */
export const transformFactToGraphQL = (item: any) => {
    if (!item || !('fields' in item)) return null;

    return {
        __typename: 'Fact' as const,
        header: item.fields.header || null,
        fact: item.fields.fact || null,
        sys: {
            __typename: 'Sys' as const,
            id: item.sys.id,
        },
        link: item.fields.link ? transformLinkToGraphQL(item.fields.link) : null,
    };
};
